<template>
  <font-awesome-icon
    :icon="'spinner'"
    spin
    :class="header ? 'destaque-header' : 'destaque'"
    v-if="isLoading"
  />
  <span :class="header ? 'destaque-header' : 'destaque'" v-else>
    {{ value }}
  </span>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: true
    },
    header: {
      default: false
    }
  }
}
</script>

<style scoped>
.destaque-header {
  color: #f0f8ff;
}

.destaque {
  font-weight: 600;
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/ValorDestaque/index.vue